import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExportGreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.875 11.5278V15.625C16.875 16.3154 16.3154 16.875 15.625 16.875H4.375C3.68464 16.875 3.125 16.3154 3.125 15.625V4.375C3.125 3.68464 3.68464 3.125 4.375 3.125H8.47222",
			stroke: "#72A11A",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.875 3.125L8.125 11.875",
			stroke: "#72A11A",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.875 8.125L16.875 3.125L11.875 3.125",
			stroke: "#72A11A",
			strokeLinecap: "round"
		})
	]
});
export default SvgExportGreen;
